<template>
  <div class="px-2" style="height: calc(100vh - 65px); overflow-y: auto">
    <el-dialog width="70vw" title="Chi tiết đơn hàng" v-if="showDetailOrder" :visible.sync="showDetailOrder"
               :destroy-on-close="true">
      <OrderDetail :order="order" />
    </el-dialog>
    <div class="p-2 pt-3 mt-2 rounded-2 " style="background-color: rgb(234, 237, 240)" v-for="(item,index) in orderHistory"
         :key="index">
      <div class="d-flex justify-content-between ">
        <div class="fw-bold">{{ convertTime(item.createdAt) }}</div>
        <el-badge class="fw-semibold px-1 font-size-11"
                  :style="{color: app.colorOrder[item.state], 'background-color': setTransparencyHex(app.colorOrder[item.state],0.2),'border-color': setTransparencyHex(app.colorOrder[item.state],0.2),'margin':'1px 4px 3px 1px','border-radius':'4px'}">
          {{ item.state }}
        </el-badge>
      </div>
      <div>
        <div class="fw-bold mt-2 mb-1">Mã đơn hàng</div>
        <div class="px-2 py-1" style="background-color: #fff; border: 1px solid #DCDFE9; border-radius: 4px">
                  <span class="text-primary ml-1">
                    {{ item.code }}
                  </span>
          <span class="text float-end ">
          <el-tooltip class="item" effect="dark" content="Sao chép" placement="top">
             <i class="pointer   el-icon-copy-document mt-1" @click="copy(item.code)">
             </i>
          </el-tooltip>
          </span>
        </div>
      </div>
      <div>
        <div class="fw-bold mt-2">Danh sách sản phẩm</div>
        <div class="card-edge mt-1 ">
          <div class="mt-1" v-for="(product,index)  in item.swItems" :key="index">
            <div class="clearfix">
              <el-image class="rounded me-2 border"
                        :src="(product.image !== '' && product.image != null) ? product.image : '/assets/images/empty_product.svg'"
                        style="float:left;height: 50px; width: 50px;object-fit: cover"></el-image>
              <el-tooltip class="item" effect="dark" :content="product.name" placement="top-end">
                <div class="fw-bold text-2-line">{{ product.name }}</div>
              </el-tooltip>
            </div>
            <div class="d-inline"><span class="fw-bold">Số lượng:</span> {{ product.amount }} x {{
                new Intl.NumberFormat("vi-VN", {
                  style: "currency",
                  currency: "VND"
                }).format(product.price)
              }}
            </div>
            <!--          <div class="d-inline float-end" ><span class="fw-bold">Giá: </span> {{product.price}}   </div>-->
          </div>
        </div>
        <div class="pt-2">
                <span>
                  Tổng tiền hàng:
                </span>
          <span class="float-end fw-bolder">
                  {{
              new Intl.NumberFormat("vi-VN", {
                style: "currency",
                currency: "VND"
              }).format(item.totalPrice - item.shippingFee + (item.paid + item.discount))
            }}
                </span>
        </div>
        <div class="pt-1">
                <span>
                  Phí vận chuyển:
                </span>
          <span class="float-end fw-bold">
                  {{
              new Intl.NumberFormat("vi-VN", {
                style: "currency",
                currency: "VND"
              }).format(item.shippingFee)
            }}
                </span>
        </div>
        <div class="pt-1 pb-2">
                <span>
                  Thanh toán:
                </span>
          <span class="float-end text-danger fw-bolder">
                  {{
              new Intl.NumberFormat("vi-VN", {
                style: "currency",
                currency: "VND"
              }).format(item.totalPrice)
            }}
                </span>
        </div>

        <div @click="showOrderDetail(item)" style=" background-color: #FFFFFF"
             class="text-center pointer hover-order-button">
          <el-button class="fw-bolder text-primary" style="width: 100%">Xem chi tiết</el-button>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import OrderDetail from "./OrderDetail";

export default {
  name: "OrderHistory",
  components: { OrderDetail },
  props: {
    conversation: {
      type: Object
    }
  },
  data() {
    return {
      showDetailOrder: false,
      orderHistory: [],
      order: {}
    };
  },
  methods: {
    showOrderDetail(item) {
      this.order = item;
      this.showDetailOrder = true;
    },
    copy(code) {
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Đã sao chép");
    }

  },
  created() {
    this.$http.get("/api/stock/orders", {
      params: {
        zaloConversationId: this.conversation.id
      }
    }).then((resp) => {
      this.orderHistory = resp.data;
    });
  }
};
</script>

<style scoped>

.card-edge {
  border-radius: 5px;
  padding: 5px;
  border: solid #d6d8d9 1px;
}
</style>